import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Popover } from 'antd';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import ReactECharts from 'echarts-for-react';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';

import './analytics.css';


var cc_data;



// const countriesInfo = Object.keys(countrycodeLatlong).map(code =>({code, lat:countrycodeLatlong[code][0], long:countrycodeLatlong[code][1], name: countries[code.toUpperCase()]}))

class NewUsersTotalCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	async componentDidUpdate(prevProps) {
	}


	// renameAppName(value){
	// 	switch(value){
	// 		case "Vivamax" :
	// 			return "Android Vivamax";
	// 		case "Viva One" :
	// 			return "Android Vivaone";
	// 		case "Viva STORE" :
	// 			return "iOS Vivamax";
	// 		case "Vivaone STORE" :
	// 			return "iOS Vivaone";
	// 		default :
	// 			return "Other";
	// 	}

	// }

	render() {
		const { opensearchNewUserTotalList, loading, userTheme} = this.props;

		cc_data = opensearchNewUserTotalList || [];
		cc_data = cc_data.sort((a, b) => a.key - b.key);
		//cc_data = cc_data.map(({key, doc_count}) => ({name: key, value: doc_count}));
		let seriesarray = [];

		cc_data.forEach((d)=>{
			// seriesarray.push({name : this.renameAppName(d.key), value: d.doc_count})
			seriesarray.push({name : d.key, value: d.doc_count})
		})

		const options = {
			tooltip: {
				trigger: 'item'
			},
			legend: {
				type: 'scroll',
				top: '5%',
				left: 'center'
			},
			series: [
				{
				//name: 'Total New Users',
				type: 'pie',
				radius: ['40%', '70%'],
				avoidLabelOverlap: false,
				itemStyle: {
					borderRadius: 10,
					borderColor: '#fff',
					borderWidth: 2
				},
				label: {
					show: false,
					position: 'center'
				},
				emphasis: {
					label: {
					show: true,
					fontSize: 40,
					fontWeight: 'bold'
					}
				},
				labelLine: {
					show: false
				},
				data: seriesarray
				}
			]
			};

		return (
			<Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`Total New Users  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='NewUsersTotalCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={seriesarray.map(c => ({ platforms: c.name, count: c.value }))} target="_blank" filename={"Total New Users.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
					<Col span={24}>
						<ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={options} notMerge={true} showLoading={loading} loadingOption={{ color: "#74add1" }} />
					</Col>
				</Row>
			</Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchNewUserTotalList : state.analytics.opensearchNewUserTotalList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewUsersTotalCard));
